export const SET_LOGIN = 'SET_LOGIN';
export const SET_CATALOGUE_DATA = 'SET_CATALOGUE_DATA';
export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const SET_ITEMS_DATA = 'SET_ITEMS_DATA';
export const SET_LOADING = 'SET_LOADING';
export const SET_HAS_MORE = 'SET_HAS_MORE';
export const SET_PAGES = 'SET_PAGES';
export const INCREMENT_PAGES = 'INCREMENT_PAGES';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_LOGOUT = 'SET_LOGOUT';
export const SET_ADD_CART = 'SET_ADD_CART';
export const SET_ACTIVE_CATALOGUE_ID = 'SET_ACTIVE_CATALOGUE_ID';
export const REMOVE_CART = 'REMOVE_CART';
export const SEARCH_ITEM_DATA = 'SEARCH_ITEM_DATA';
export const SET_GUID = 'SET_GUID';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_DRAWER = 'SET_DRAWER';
export const SET_CATALOGUE_STATUS = 'SET_CATALOGUE_STATUS';
export const SET_ITEM_IS_SELECTED = "SET_ITEM_IS_SELECTED";
export const SET_ITEM_IS_NOT_SELECTED = "SET_ITEM_IS_NOT_SELECTED";
export const INCREMENT_CART_QUANTITY = "INCREMENT_CART_QUANTITY";
export const DECREMENT_CART_QUANTITY = "DECREMENT_CART_QUANTITY";
export const HANDLE_FILTERS_IS_CHECKED = "HANDLE_FILTERS_IS_CHECKED";
export const HANDLE_SELECT_ALL_FILTERS = "HANDLE_SELECT_ALL_FILTERS";
export const SET_FILTER_TAB_OPTION = 'SET_FILTER_TAB_OPTION';
export const ENABLE_CATALOGUE_DRAWER = 'ENABLE_CATALOGUE_DRAWER';
export const DISABLE_CATALOGUE_DRAWER = 'DISABLE_CATALOGUE_DRAWER';
export const SET_ITEM_EDIT_IS_SELECTED = 'SET_ITEM_EDIT_IS_SELECTED';
export const SET_ITEM_EDIT_NOT_SELECTED = 'SET_ITEM_EDIT_NOT_SELECTED';
export const SET_CART_REMARKS = 'SET_CART_REMARKS';
export const HANDLE_DATE_FILTERS = 'HANDLE_DATE_FILTERS';
export const SCROLL_POSITION_FINDER = 'SCROLL_POSITION_FINDER';
export const SET_TOTAL_CART_ITEMS = 'SET_TOTAL_CART_ITEMS';
export const SET_CUSTOM_CATALOGUE = 'SET_CUSTOM_CATALOGUE';
export const SET_MOBILE_NUMBER = 'SET_MOBILE_NUMBER';
export const HANDLE_ELASTIC_FILTERS_IS_CHECKED = "HANDLE_ELASTIC_FILTERS_IS_CHECKED";
export const SET_ELASTIC_FILTER_DATA = 'SET_ELASTIC_FILTER_DATA';
export const CLEAR_SEARCH_TEXT = "CLEAR_SEARCH_TEXT";
export const GROUP_PARTY_LOADING = "GROUP_PARTY_LOADING";
export const GROUP_PARTY_DATA = "GROUP_PARTY_DATA";
export const GROUP_PARTY_FILTER_HEADING = "GROUP_PARTY_FILTER_HEADING";
export const PARTY_FILTER_STATE = "PARTY_FILTER_STATE";
export const TEMPLATE_STATE = "TEMPLATE_STATE";
export const SORT_FILTER = "SORT_FILTER";
export const SET_PARTY_FILTER_SORT_FILTER = "SET_PARTY_FILTER_SORT_FILTER";
export const SET_SEARCH_MODE = "SET_SEARCH_MODE";
export const SET_MULTIPLE_ITEM_CONDITION = "SET_MULTIPLE_ITEM_CONDITION";
export const SET_MULTIPLE_REMOVE_ITEM_CONDITION = "SET_MULTIPLE_REMOVE_ITEM_CONDITION";
export const SET_ALL_ITEMS = 'SET_ALL_ITEMS';
export const SET_ITEM_PK_ID = 'SET_ITEM_PK_ID';
export const SET_SORT_GROUPITEM_DATA = 'SET_SORT_GROUPITEM_DATA';
export const SET_SORT_HEADING_GROUP = 'SET_SORT_HEADING_GROUP';
export const CLEAR_SORT_FILTERS_OF_GROUP = 'CLEAR_SORT_FILTERS_OF_GROUP';
export const ALL_GROUP_OPTION_LISTS = 'ALL_GROUP_OPTION_LISTS';
export const SET_SIMILAR_DATA = 'SET_SIMILAR_DATA';
export const SET_HEADER_DOCUMENT_LIST = 'SET_HEADER_DOCUMENT_LIST';
export const SET_SEARCH_BY_IMAGE = 'SET_SEARCH_BY_IMAGE';
export const SET_CLIENT_NAME = 'SET_CLIENT_NAME';
export const SET_TOP_SEARCH_COUNT = 'SET_TOP_SEARCH_COUNT';
export const SET_NAV_FROM_TO_SBI = 'SET_NAV_FROM_TO_SBI';
export const SET_VT_MID_LIST = 'SET_VT_MID_LIST';
